import React, { useState, useEffect } from "react";
import CoachLayout from "../common/CoachLayout";
import { useCoachAuthContext } from "../login/useCoachAuthContext";
import { useNavigate, useParams, Link } from "react-router-dom";
import { CoachHeader } from "../common/CoachHeader";
import API_URL from "../../api/API";
import {
    CircularProgressbarWithChildren,
    buildStyles,
} from "react-circular-progressbar";

export const CoachRunrocketTrainingDay = () => {
    const { coach } = useCoachAuthContext();
    const navigate = useNavigate();
    const { week_day, day_id } = useParams();

    const [openIndex, setOpenIndex] = useState(null); // Accordion state
    const [trainingData, setTrainingData] = useState([]); // Stores fetched training sets
    const [isLoading, setIsLoading] = useState(true); // Loading state
    const [error, setError] = useState(null); // Error state
    const [maxSpeeds, setMaxSpeeds] = useState({}); // To store max speeds for each set

    const [testResult, setTestResult] = useState(null);
    const [targetSpeed,setTargetSpeed] = useState(0);
    const [peakSpeed,setPeakSpeed] = useState(0);
    const [targetLoad,setTargetLoad] = useState(0);
    const [day_training_focus,setDayTrainingFocus] = useState('');

    const fetchTrainingData = async () => {
        try {
            const response = await fetch(`${API_URL.GET_COACH_RUNROCKET_TRAINING_TEMPLATE_DAY_SETS}${day_id}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${coach.token}`,
                },
            });

            if (!response.ok) {
                throw new Error("Failed to fetch training data");
            }

            const data = await response.json();
            setDayTrainingFocus(data.training_focus);
            setTrainingData(data.sets || []); // Set data, fallback to empty array

            // Step 2: Fetch max speeds for each set if they exist
            const maxSpeedsResponse = await fetch(`${API_URL.GET_COACH_RUNROCKET_TRAINING_DAY_MAXSPEEDS}${day_id}/${coach.id}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${coach.token}`,
                },
            });

            if (maxSpeedsResponse.ok) {
                const maxSpeedData = await maxSpeedsResponse.json();

                // Ensure maxSpeedData.data is an array
                if (Array.isArray(maxSpeedData.data)) {
                    const maxSpeedsObj = {};

                    // Process each set and store maxspeed by set_id
                    maxSpeedData.data.forEach((set) => {
                        maxSpeedsObj[set.set_id] = set.maxspeed; // Store maxspeed per set_id
                    });

                    // Update the state with maxspeed values
                    setMaxSpeeds(maxSpeedsObj);
                } else {
                    console.warn("maxSpeedData.data is not an array:", maxSpeedData.data);
                }
            }
        } catch (error) {
            setError(error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchTestResults = async () => {
        try {
            const response = await fetch(API_URL.GET_COACH_RUNROCKET_TEST_RESULT + coach.id, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${coach.token}`,
                },
            });
            
            if (!response.ok) {
                throw new Error("Failed to fetch test results");
            }
            
            const data = await response.json();
            setTestResult(data.data);
            console.log(data.data);
            //build logic here such that based on the training focus for that day,
            //determine the target speed and target load to use. 

            if(day_training_focus === "Technical"){
                setTargetLoad(data.data.target_load_technical);
                setTargetSpeed(data.data.target_speed_technical);
            }
            else if(day_training_focus === "Speed - Strength"){
                setTargetLoad(data.data.target_load_speedstrength);
                setTargetSpeed(data.data.target_speed_speedstrength);
            }
            else if(day_training_focus === "Power"){
                setTargetLoad(data.data.target_load_power);
                setTargetSpeed(data.data.target_speed_power);
            }
            else if(day_training_focus === "Strength - Speed"){
                setTargetLoad(data.data.target_load_strengthspeed);
                setTargetSpeed(data.data.target_speed_strengthspeed);
            }
          

        } catch (error) {
            console.log(error.message);
        }
    };

    // Fetch training sets for the specific day
    useEffect(() => {
        fetchTrainingData();
       // fetchTestResults();
    }, [day_id, coach.token]);

    // Fetch training sets for the specific day
    useEffect(() => {
       // fetchTrainingData();
        fetchTestResults();
    }, [day_training_focus,day_id, coach.token]);

    // Toggle accordion logic for each index
    const toggleAccordion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    // Handle the "plus" button click to save maxspeed
    const handleSaveMaxSpeed = async (set_id) => {
        const maxSpeed = maxSpeeds[set_id]; // Get the maxspeed from state
        if (!maxSpeed) {
            alert("Please enter a max speed value.");
            return;
        }

        try {
            const response = await fetch(`${API_URL.POST_COACH_RUNROCKET_TRAINING_DAY_SET_MAXSPEED}${set_id}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${coach.token}`,
                },
                body: JSON.stringify({
                    maxspeed: parseFloat(maxSpeed), // Convert to float
                    coach_id: coach.id, // Pass the coach_id
                    day_id: day_id, // Pass the day_id
                    set_id: set_id, // Pass the set_id
                    week_day: week_day,
                    day_training_focus: day_training_focus,
                }),
            });

            if (!response.ok) {
                throw new Error("Failed to save maxspeed.");
            }

            const data = await response.json();
            console.log("Maxspeed saved:", data);

            // Update UI to show that maxspeed was saved (Optional)
            alert("Maxspeed saved successfully!");

        } catch (error) {
            console.error("Error saving maxspeed:", error);
            alert("Error saving maxspeed.");
        }
    };

    // Handle change in maxspeed input
    const handleMaxSpeedChange = (e, set_id) => {
        const value = e.target.value;
        setMaxSpeeds((prev) => ({
            ...prev,
            [set_id]: value, // Update the maxspeed value for the specific set
        }));
    };

    return (
        <CoachLayout>
            <div className="bg-[#f6f6f6] h-full">
                <div className="bg-white">
                    <CoachHeader />
                </div>
                <div className="relative h-full bg-[#f6f6f6] pb-5 overflow-y-auto">
                    <div className="w-full max-w-2xl mx-auto px-5 py-5">
                        {/* Header with Back Navigation */}
                        <div className="relative text-start mb-[30px]">
                            <p className="text-black text-base font-normal pl-5 capitalize">
                                {week_day}
                            </p>
                            <Link to="/coach/tools/runrocket/training-weeks">
                                <button onClick={() => navigate(-1)} className="absolute left-0 top-1/2 -translate-y-1/2">
                                    <ArrowL />
                                </button>
                            </Link>
                        </div>

                        {/* Circular Progress Indicator */}
                        <div className="pt-[30px] mx-auto">
                            <div style={{ width: 174, height: 174 }} className="mx-auto relative">
                                <CircularProgressbarWithChildren
                                    strokeWidth={5}
                                    value={(targetSpeed*100)/10}
                                    styles={buildStyles({
                                        pathColor: "#6D48C1", // Progress path color
                                        trailColor: "#E5E5E5", // Background path color
                                    })}
                                >
                                    <p className="text-black text-5xl font-normal mb-2">{targetSpeed}</p>
                                    <span className="text-[#A5A5A5] text-[12px] font-normal leading-[91%] uppercase">
                                        Target Speed
                                    </span>
                                </CircularProgressbarWithChildren>

                                {/* Centered Training Focus Text */}
                                <p className="text-black text-lg font-semibold mt-3 text-center w-full">
                                    {day_training_focus}
                                </p>
                            </div>
                        </div>

                        {/* Loading & Error Handling */}
                        {isLoading ? (
                            <p className="text-center text-gray-600">Loading training data...</p>
                        ) : error ? (
                            <p className="text-center text-red-500">{error}</p>
                        ) : (
                            <div className="my-[60px]">
                                {trainingData.length === 0 ? (
                                    <p className="text-center text-gray-500">No sets available.</p>
                                ) : (
                                    trainingData.map((item, index) => (
                                        <div key={index} className="border-black/20 border-b">
                                            {/* Row with Clickable Area */}
                                            <div
                                                className="flex flex-row items-center justify-between gap-[20px] py-[14px] cursor-pointer"
                                                onClick={() => toggleAccordion(index)}
                                            >
                                                <div className="space-y-2 text-center">
                                                    <p className="text-[#a5a5a5] text-xs font-normal uppercase">
                                                        REPS
                                                    </p>
                                                    <p className="text-black text-sm font-normal">{item.reps}</p>
                                                </div>
                                                <div className="space-y-2 text-center">
                                                    <p className="text-[#a5a5a5] text-xs font-normal uppercase">
                                                        Distance
                                                    </p>
                                                    <p className="text-black text-sm font-normal">{item.distance}</p>
                                                </div>
                                                <div className="space-y-2 text-center">
                                                    <p className="text-[#a5a5a5] text-xs font-normal uppercase">
                                                        LOAD
                                                    </p>
                                                    <p className="text-black text-sm font-normal">{targetLoad}</p>
                                                </div>
                                                <div className="w-fit h-fit">
                                                    <span
                                                        className={`transform transition-transform ${
                                                            openIndex === index ? "rotate-180" : ""
                                                        }`}
                                                    >
                                                        <ArrowD />
                                                    </span>
                                                </div>
                                            </div>

                                            {/* Expanded Section (Shown When Clicked) */}
                                            {openIndex === index && (
                                                <div className="flex flex-col gap-5 p-4 bg-[#ECECEC]">
                                                    <div className="relative w-full max-w-[144px] border-b border-black mx-auto">
                                                        <span className="uppercase text-[#a5a5a5] text-xs font-normal mx-auto w-fit block">
                                                            Actual Speed
                                                        </span>
                                                        <div className="relative">
                                                            <input
                                                                type="text"
                                                                placeholder="Your max speed"
                                                                value={maxSpeeds[item._id] || ""}
                                                                onChange={(e) => handleMaxSpeedChange(e, item._id)} // Update state on change
                                                                className="bg-transparent w-full outline-none p-[10px_30px_10px_0px] placeholder:text-[#ADADAD] text-black text-base font-normal"
                                                            />
                                                            <span
                                                                className="absolute right-0 top-1/2 -translate-y-1/2"
                                                                onClick={() => handleSaveMaxSpeed(item._id)} // Save maxspeed on click
                                                            >
                                                                <Add />
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <p className="text-black text-xs font-normal">
                                                        {item.rest ? item.rest : "No rest details available."}
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    ))
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </CoachLayout>
    );
};

// SVG Icons
const ArrowD = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none">
        <path d="M13 1L7 7L1 1" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const ArrowL = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
        <path d="M7 13L1 7L7 1" stroke="#000000" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const Add = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 21 22" fill="none">
        <path d="M10.5 1V21M0.5 11C8.31049 11 12.6895 11 20.5 11" stroke="#000" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
